class ProductCompareSwitch extends HTMLElement { 
    constructor(){
      super(),
      (this.cookieKey = "compareIsActive"), 
      (this.classes = { isActive: "product-comparing" }),
      (this.checkboxEl = this.querySelector( "input" )), 
      (this.onChangeHandler = this.onChange.bind(this));
    }
    connectedCallback() {
      this.init(), 
      this.checkboxEl.addEventListener("change", this.onChangeHandler);
      this.addEventListener('keydown', e => {
        if (e.key === ' ' || e.key === 'Enter') {
          e.preventDefault();
          this.checkboxEl.checked = !this.checkboxEl.checked;
          this.onChange({preventDefault(){}});
        }
      });
    }
    disconnectedCallback() {
      this.checkboxEl.removeEventListener("change", this.onChangeHandler);
    }
    init() {
      try {
        const isActive = window.localStorage.getItem(this.cookieKey) === "true";
        if (isActive) {
          this.checkboxEl.checked = isActive;
          this.handleChange(isActive);
        }
      } catch (error) {
        console.warn('Failed to read compare switch state:', error);
      }
    }
    onChange(evt) {
      evt.preventDefault(),
      this.handleChange(this.checkboxEl.checked);
    }
    handleChange(isActive) {
      try {
        if (isActive) {
          document.body.classList.add(this.classes.isActive);
        } else {
          document.body.classList.remove(this.classes.isActive);
        }
        window.localStorage.setItem(this.cookieKey, isActive);
      } catch (error) {
        console.warn('Failed to save compare switch state:', error);
      }
    }
  }
  customElements.define("compare-switch", ProductCompareSwitch);
  
  class ProductCompareCheckbox extends HTMLElement {
    constructor() {
      super(), (this.checkboxEl = this.querySelector(
        "input"
      )), (this.onChangeHandler = this.onChange.bind(this));
    }
    connectedCallback() {
      this.init(), 
      this.products = Utils.getSelectedProduct();
      this.checkboxEl.addEventListener(
        "change",
        this.onChangeHandler
      );
      this.addEventListener('keydown', e => {
        if (e.key === ' ' || e.key === 'Enter') {
          e.preventDefault();
          this.checkboxEl.checked = !this.checkboxEl.checked;
          this.onChange({preventDefault(){}});
        }
      });
    }
    disconnectedCallback() {
      this.checkboxEl.removeEventListener("change", this.onChangeHandler);
    }
    init() {
      const { productId } = this.checkboxEl.dataset;
      this.checkboxEl.checked = Utils.isProductInList(productId);
    }
    onChange(evt) {
      // evt.preventDefault();
      const { productId, productUrl } = this.checkboxEl.dataset;
      this.checkboxEl.checked
        ? Utils.addToProductList(productId, productUrl) ||
          (this.checkboxEl.checked = !1)
        : Utils.removeFromProductList(productId);
    }
  }
  customElements.define("compare-checkbox", ProductCompareCheckbox);